<template>
  <v-dialog
      v-model="value"
      persistent
      :max-width="maxWidth"
      >
      <v-card
               
      >
          <v-card-title
            class="text-h5"
          >
            {{title}}
          </v-card-title>

          <v-card-text
            style="min-height: 500px;"
          >
            <shift-detail
              v-if="selectedShift"
              :shift="selectedShift"
              :filters="filters"
              :pod="pod"
              :group_id="group_id"
              :key="`shiftdetail_${selectedShift.id}`"
              :reload="reloadShift"
              @changed="shiftChanged"
              :readOnly="readOnly"
            />
            <shift-list
              v-else
              :shifts="shifts"
              :filters="filters"
              @select="doSelect"
              :refresh="refreshList"
            />
      
          </v-card-text>
          <v-card-actions>
            
              <v-btn
                @click="doNew()"
                v-if="(!readOnly) && (selectedShift ? false : true)"
              >
                New Shift
              </v-btn>   

            <v-spacer></v-spacer>
              <v-btn
                @click="save()"
                v-if="state.startsWith('detail')"
                :disabled="saveDisabled"
                :loading="saving"
                width="80"
              >
                Save
              </v-btn>              


              <v-btn
                @click="cancel()"
                width="80"
              >
                {{cancelCaption}}
              </v-btn>              

          </v-card-actions>          
      </v-card>

  </v-dialog>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import scheduleShiftList from '@/views/apps/scheduling-new/components/scheduleShiftList';
import scheduleShiftDetail from '@/views/apps/scheduling-new/components/scheduleShiftDetail';

  export default {
    props: {
      value: {
        default: false,
        type: Boolean
      },
      'max-width': {
        default: '500',
        type: String
      },
      shifts: {
          type: Array,
          default: () => []
      },
      filters: {
          type: Array,
          default: () => []
      },      
      title: {
        default: 'Shifts',
        type: String
      },
      facilities: {
          type: Array,
          default: () => []
      }, 
      pod: {
          type: Object,
          default: () => {}
      }, 
      group_id: {
          type: String,
          default: ''
      }, 
      calendar_date: {
          type: String,
          default: ''
      },     
      refreshList: {
        default: '',
        type: String
      },   
      readOnly: {
          default: false,
          type: Boolean
      },                                     
    },
    components: {
        'shift-list': scheduleShiftList,   
        'shift-detail': scheduleShiftDetail
    },    
    data: () => ({
      selectedShift: null,
      shiftEdits: {},
      reloadShift: null,
      saving: false
    }),
    mounted() {
    },
    methods: {
      ...mapActions('schedule',['saveShift']),
      arrayString(arr) {   

        if (!arr) {
          arr = []
        }     
        let temp = JSON.parse(JSON.stringify(arr))

        let temp2 = temp.sort()
        
        return temp2.join(',')
      },
      
      shiftChanged (props) {

        for (let prop in props) {
          
          switch (prop) {
            //case 'rounding_outpatient':

              //break
            default:
              this.$set(this.shiftEdits,prop,props[prop])
              break
          }
        }

      },
      doSelect (shift) {

        this.selectedShift = shift

        this.shiftEdits = {}
      },
      doNew () {

        this.selectedShift = {
          start:"07:00:00",
          end:"19:00:00",
          weekdays: []
        }
        this.shiftEdits = {}

      },
      cancel () {

        if (this.state === 'detail_dirty') {
          this.shiftEdits = {}
          this.reloadShift = (new Date()).toISOString()
        } else if (this.state === 'detail') {
          this.selectedShift = null
        } else {
          this.$emit('input', false)          
        }
      },
      saveFinished (success)  {

        if (success) {
          this.reloadShift = (new Date()).toISOString()
          this.selectedShift = null
        }
        this.saving = false
      },
      async save () {

        this.saving = true

        let params
        if (this.selectedShift.id) {
          params = JSON.parse(JSON.stringify(this.shiftEdits))

          params.id = this.selectedShift.id
          params.calendar_date = this.calendar_date
          params.pod_id = this.pod.id
          params.callback = this.saveFinished
        } else {
          params = JSON.parse(JSON.stringify(this.selectedShift))

          for (let prop in this.shiftEdits) {
            params[prop] = this.shiftEdits[prop]
          }

          params.calendar_date = this.calendar_date
          params.pod_id = this.pod.id
          params.callback = this.saveFinished

        }

        this.$emit('saveShift', params)
      },      
    },
    computed: {
      saveDisabled () {

        if (!this.selectedShift.id) {


          if (!this.shiftEdits.name) {
            return true
          }

          let start = this.selectedShift.start

          if (this.shiftEdits.start) {
            start = this.shiftEdits.start
          }

          if (!start) {
            return true
          }

          let end = this.selectedShift.start

          if (this.shiftEdits.end) {
            end = this.shiftEdits.end
          }

          if (!end) {
            return true
          }

          return false

        }
        return this.state !== 'detail_dirty'
      },
      state () {
        if (!this.selectedShift) {
          return 'list'
        } else {
          if (this.shiftDirty) {
            return 'detail_dirty'
          } else {
            return 'detail'
          }
        }        
      },
      cancelCaption () {
        switch (this.state) {
          case 'detail':
            return 'Back'
          case 'detail_dirty':
            return 'Cancel'
          default:
            return 'Close'          
        }
      },

      shiftDirty () {

        let dirty = false
        for (let prop in this.shiftEdits) {
          switch (prop) {
            case 'weekdays':
              let wds = this.selectedShift.weekdays
              if (!wds.length) {
                wds  = ["0","1","2","3","4","5","6"]
              }

              let as1 = this.arrayString(this.shiftEdits[prop])
              let as2 = this.arrayString(wds)

              if (as1 != as2) {
                dirty = true
              }

              break

            case 'rounding_facilities':

              let rf1 = this.arrayString(this.shiftEdits[prop])
              let rf2 = this.arrayString(this.selectedShift.rounding_facilities)

              if (rf1 != rf2) {
                dirty = true
              }

              break


            default: 
              if (this.shiftEdits[prop] != this.selectedShift[prop]) {
                dirty = true
              }
          }
        }

        return dirty
      },

    },
    watch: {
        value (newValue, oldValue) {
          this.selectedShift = null
        },
    }
  }
</script>

